import { Button, Form, Row, Col } from 'react-bootstrap';
import { useState } from 'react';

function TextParticipation({
    participation,
    sendingParticipationState,
    changerEtapeCollecteParticipationTexte
}) {

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(true)

    const handleUpdateText = async (e) => {
        let val = e.target.value;
        participation.textAnswer = val.trim();
        setDisabled(participation.textAnswer === '')
        setValue(val);
    }
    return (
        <>
            <Row>
                <Col>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={handleUpdateText}
                        disabled={sendingParticipationState === "sended"}
                        value={value}
                        placeholder='Saisissez votre texte ici'
                    />
                </Col>
            </Row>
            <Row className="custom-commandes">
                <Col>
                    <Button onClick={changerEtapeCollecteParticipationTexte} disabled={disabled}>Continuer</Button>
                </Col>
            </Row>
        </>
    );
}

export default TextParticipation;